// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2QXQw","rootParamsCollapsed":"styles_rootParamsCollapsed__35IPh","rootPreviewFull":"styles_rootPreviewFull__3vGNC","loader":"styles_loader__2mf6t"};